import { componentSelector } from 'wordpress/selectors'
import Button from '@components/Button'
import '../styles/Corporate.scss'

const corporateConfigurationSelector = componentSelector('corporate')

export const Corporates = ({ corporate }) => {
    const getLink = () =>
        corporate.buttonAction === 'page'
            ? {
                  href: corporate.page,
              }
            : {
                  href: corporate.url,
                  external: true,
              }

    return (
        <div className="corporate container-fluid">
            <div className="inner-container">
                <Image className="img-container" image={corporate.image} background />
                <div className="info-container">
                    <h1>{corporate.title}</h1>
                    <div className="divider">
                        <hr />
                    </div>
                    <div className="text text-large">{corporate.content}</div>
                    <Button btnStyle="outline-invert" className="font-weight-bold" inline {...getLink()}>
                        {corporate.buttonLabel}
                    </Button>
                </div>
            </div>
        </div>
    )
}

export const Corporate = corporate => (corporate.enabled ? <Corporates corporate={corporate} /> : null)

export default connect(corporateConfigurationSelector)(Corporate)
